export enum ChangeHoldingCompanyStepsEnum {
  FormDescription = 0,
  ChangeHoldingCompany = 1
}
